import _ from 'lodash'
import Backbone from 'backbone'
import BusyButton from 'scoreboard/components/busy-button'
import calendars from 'scoreboard/components/calendars'
import CalendarRangeSelector from 'scoreboard/components/calendar-range-selector'
import template from './share-dashboard.hbs'
import linksTemplate from './shared-dashboard-links.hbs'
import linksContext from './shared-dashboard-links-context'
import errors from 'scoreboard/components/setup-errors'
import licenseRestriction from 'scoreboard/components/license-restriction'
import appDisplay from 'scoreboard/components/app-display'
import ErrorView from 'scoreboard/components/error-view'
import errorHandler from 'scoreboard/components/error-handler'

var ShareDashboard = Backbone.View.extend({

	className: 'share-dashboard',

	tagName: 'form',

	events: {
		'click .button-primary': 'createLink'
	},

	render: function () {
		this.removeChildren()

		// Insert template markup
		var context = linksContext(this.model.attributes, this.model.section)
		this.$el.html(template(context))
		this.$el.append(linksTemplate(context))

		//shared view so its visible but it needs hidden here
		this.$('.links').addClass('is-not-displayed')

		const calendarId = this.model.get('calendarId') || calendars.calendars[0].id
		this.rangeSelector = new CalendarRangeSelector({
			allowCurrentCalendar: false,
			canChangeCalendar : true,
			singlePeriod: true,
			range: {calendarId, relative: true, first:0, last:0}
		})

		this.rangeSelector.setElement(this.$('.toggler-rows')).render()

		this.shareButton = new BusyButton({el: this.$('.button-primary')})

		if (this.model.section === 'forms') {
			this.$('.panel').addClass('is-not-displayed')
		}

		return this
	},

	createLink() {
		this.$el.addClass('is-submitting-form') // Doesn't use formView so add class manually
		this.shareButton.loading()

		let data = {}
		// form embedded resources will not have calendar information
		if (this.model.section != 'forms') {
			const {calendarId, relative, first} = this.rangeSelector.model.attributes
			data = {calendarId}
			if (relative) {
				data.periodDelta = first
			} else {
				data.periodId = first
			}
		}

		this.model.save(data, {
			error: (model, xhr) => errorHandler(xhr, { handler: () => {
				if (xhr.responseJSON.messageCode == 'admin.licenses.error.sharedDashboards') {
					appDisplay.replaceDialog(licenseRestriction.sharedDashboardRestriction())
				} else {
					appDisplay.replaceDialog(new ErrorView(errors.errorViewOptions(xhr.status, xhr.responseJSON)))
				}
				return true
			}}),
			success: (model, response, options) => {
				this.$el.removeClass('is-submitting-form')
				this.render()
				this.toggleLinks()
			}
		})
	},

	/**
	 * Displays the appropriate step in the flow (we're using a single template)
	 */
	toggleLinks: function() {
		this.$('.links, .panel').removeClass('is-not-displayed')
		// `.create-link` is no longer needed, so we can remove from dom so correct css gets inherited for `.links`
		this.$('.create-link').remove()
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.removeChildren()
	},

	removeChildren: function () {
		_.invokeMap([this.shareButton, this.rangeSelector], 'remove')
	}

})

export default ShareDashboard

ShareDashboard.__filename__ = 'dashboards/share-dashboard.js'
